import { NgModule } from '@angular/core';
import { FindLanguageFromKeyPipe } from './findLanguageFromKeyPipe';

@NgModule({
	declarations: [FindLanguageFromKeyPipe],
	imports: [],
	exports: [FindLanguageFromKeyPipe],
	providers: [],
})
export class FindLanguageFromKeyPipeModule {}
